import React from 'react';
import {
  Box,
  CssBaseline,
  ThemeProvider,
  Typography,
} from '@mui/joy';
import { Container } from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import { theme, primaryColor } from '../../main/theme/constants';
import PublicLanguageToggle from './PublicLanguageToggle';

export default function PublicBrandedPageShell({
  siteIcon,
  siteName,
  pageTitle,
  children,
  footer,
}) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)',
          py: { xs: 4, sm: 8 },
        }}
      >
        <Container maxWidth="sm">
          <PublicLanguageToggle />
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            {siteIcon ? (
              <Box
                component="img"
                src={siteIcon}
                alt={siteName || pageTitle}
                sx={{
                  display: 'block',
                  mx: 'auto',
                  mb: 1.5,
                  maxWidth: 160,
                  maxHeight: 80,
                  objectFit: 'contain',
                }}
              />
            ) : (
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: '20px',
                  bgcolor: '#EDE9FE',
                  mx: 'auto',
                  mb: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <PaymentIcon sx={{ color: primaryColor, fontSize: 36 }} />
              </Box>
            )}
            {siteName ? (
              <Typography level="h2" sx={{ fontWeight: 800, color: '#1f2937', mb: 0.5 }}>
                {siteName}
              </Typography>
            ) : null}
            {pageTitle ? (
              <Typography
                level={siteName ? 'body-md' : 'h2'}
                sx={{
                  fontWeight: siteName ? 600 : 800,
                  color: siteName ? '#6b7280' : '#1f2937',
                }}
              >
                {pageTitle}
              </Typography>
            ) : null}
          </Box>
          {children}
          {footer}
        </Container>
      </Box>
    </ThemeProvider>
  );
}
